import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Packages
import $ from 'jquery'

// Components
import Logo from '../Global/Logo'
import UnauthenticatedNav from '../Global/UnauthenticatedNav'
import AuthenticatedNav from '../Global/AuthenticatedNav'

class Header extends Component {

  static propTypes = {
    path: PropTypes.string.isRequired,
    authenticated: PropTypes.bool,
  }

  state = {
    menuIsOpen: false
  }

  isActive(linkUrl) {
    if (this.props.path === linkUrl) {
      return 'active'
    }
  }

  componentDidMount() {
    var nav = $('[data-structure="nav"]')

    // MENU RESET
    $(window).resize(() => {
      if ($(window).width() > 680) {
        this.setState(state => ({
          ...state,
          menuIsOpen: false
        }))
        nav.show()
      } else {
        if(!this.state.menuIsOpen) {
          nav.hide()
        }
      }
    }) // END WINDOW RESIZE
  }

  handleMenuButtonClick(event) {
    var nav = $('[data-structure="nav"]')

    clearTimeout($(this).data('menuTime'))
    var menuTime = setTimeout(() => {

      if (this.state.menuIsOpen) {
        nav.fadeOut()
      } else {
        nav.fadeIn()
      }

      this.setState(state => ({
        ...state,
        menuIsOpen: !state.menuIsOpen
      }))

    }, 300)
    $(this).data('menuTime', menuTime)
    event.preventDefault()
  }

  renderNav() {
    const { user, path } = this.props
    const { menuIsOpen } = this.state

    if (user.isOnboarding) {
      return null
    } else if (user.isLoggedIn) {
      return (
        <AuthenticatedNav
          user={user}
          path={path}
          menuIsOpen={menuIsOpen}
        />
      )
    } else {
      return <UnauthenticatedNav/>
    }
  }

  renderMobileMenuButton() {
    const { user } = this.props

    if (user.isOnboarding) {
      return null
    } else if (user.isLoggedIn) {
      return (
        <a
          className={ `menu-button${ this.state.menuIsOpen ? ' open' : '' }` }
          data-structure="menu-button"
          onClick={event => this.handleMenuButtonClick(event)}
        >
          <span className="lines"></span>
        </a>
      )
    } else {
      return null
    }
  }

  getHeaderClasses() {
    const { isLoggedIn, isOnboarding } = this.props.user

    if (isLoggedIn && isOnboarding) {
      return ' nav-onboarding'
    } else if (isLoggedIn) {
      return ' nav-dark'
    } else {
      return ''
    }
  }

  render() {
    const { isLoggedIn, maintained_profiles, isOnboarding } = this.props.user
    const isInternal = isLoggedIn && maintained_profiles.length > 0 ? true : false
    const logoPath = isInternal ? '/' : 'https://www.lockerlinked.com/'

    return (
      <header className={`nav${this.getHeaderClasses()}`}>
        <div className="wrap">
          <Logo
            linkPath={logoPath}
            linkTitle="Locker Linked"
            isExternal={!isInternal}
            optionalClasses={isOnboarding ? 'no-pointer-events' : ''}
          />
          {this.renderMobileMenuButton()}
          {this.renderNav()}
        </div>
      </header>
    )
  }
}

const mapStateToProps =  state  => {
  return {
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  null
)(Header)



// WEBPACK FOOTER //
// ./src/components/Global/Header.js